import type { Material } from '../../types/ffe'
import type { CSVColumn } from './types'
import { formatCurrency } from '../currency'

export const getMaterialColumns = (): CSVColumn[] => [
  {
    key: 'name',
    label: 'Name',
    getValue: (material: Material) => material.name
  },
  {
    key: 'type',
    label: 'Type',
    getValue: (material: Material) => material.type
  },
  {
    key: 'supplier',
    label: 'Supplier',
    getValue: (material: Material) => material.supplier || ''
  },
  {
    key: 'supplierItemCode',
    label: 'Supplier Code',
    getValue: (material: Material) => material.supplierItemCode || ''
  },
  {
    key: 'leadTime',
    label: 'Lead Time',
    getValue: (material: Material) => material.leadTime || ''
  },
  {
    key: 'costPerUnit',
    label: 'Cost per Unit',
    getValue: (material: Material) => formatCurrency(material.costPerUnit)
  },
  {
    key: 'sellPricePerUnit',
    label: 'Sell Price per Unit',
    getValue: (material: Material) => formatCurrency(material.sellPricePerUnit)
  },
  {
    key: 'unit',
    label: 'Unit',
    getValue: (material: Material) => material.unit ?? ''
  },
  {
    key: 'margin',
    label: 'Margin %',
    getValue: (material: Material) => (material.margin ?? 0).toFixed(1)
  }
]
